import { Box, Grid, Paper, Typography } from '@material-ui/core'

import React from 'react'
import styled from 'styled-components'

import InLineBox from '../../components/inLineBox'
import { BLOG_STATUS } from '../../constants/enums/blog.enum.constant'
import { BlogDetailInterface } from '../../interfaces/blog'

const StyledPaper = styled(Paper)`
  width: 100%;
`
const Title = styled(Box)`
  height: 30px;
  margin: 20px;
  font-weight: 700;
`

const InLineContainer = styled.div`
  height: 30px;
  margin: 0px 0px 5px 0px;
`

const dateStringOption = {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric'
}

const InlineComponent = ({ items }: { items: { [key: string]: any } }) => (
  <InLineContainer>
    <InLineBox items={items} margin={2} padding={1} fontSize={13} />
  </InLineContainer>
)

const BlogDetailTitleBar = ({
  title,
  detail,
  newForm
}: {
  title: string
  detail: BlogDetailInterface | null
  newForm: boolean
}) => (
  <Grid container style={{ width: '100%' }} alignItems="stretch">
    <StyledPaper>
      <Grid item xs={12}>
        <Typography component="h2" variant="h5">
          <Title>{newForm ? 'New Blog' : title}</Title>
        </Typography>
      </Grid>
      <Grid item xs={12}>
        {detail && !newForm && (
          <>
            <InlineComponent
              items={{
                Status: BLOG_STATUS[detail.status]
              }}
            />
            <InlineComponent
              items={{
                'Created Date': new Date(
                  detail.createdTime as number
                ).toLocaleDateString('en-US', dateStringOption as any),
                'Updated Date': new Date(
                  detail.updatedTime as number
                ).toLocaleDateString('en-US', dateStringOption as any)
              }}
            />
          </>
        )}
      </Grid>
    </StyledPaper>
  </Grid>
)

export default BlogDetailTitleBar
